<!--
  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
  ~ No part of this publication may be reproduced, distributed,
  ~ or transmitted in any form or by any means, including photocopying, recording,
  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
  ~ except in the case of brief quotations embodied in critical
  ~ reviews and certain other noncommercial uses permitted by copyright law.
  ~  author : vhe
  ~  date : 02/03/2021 07:39
  -->

@if (sections) {
  <div class="hours-column">
    <div
      class="blank-group-block"
      [ngClass]="{ 'with-group': withGroup() }"
    ></div>
    @for (hour of sections; track hour.time) {
      <div class="section" [ngStyle]="{ height: hour.length * 30 + 'px' }">
        <span class="time">
          {{ hour.hour >= 10 ? hour.hour : '0' + hour.hour }}
          :{{
            hour.zones[0].minutes >= 10
              ? hour.zones[0].minutes
              : '0' + hour.zones[0].minutes
          }}
        </span>
      </div>
    }
    @if (
      lastSection &&
      lastSection.length === hourDivCount() &&
      lastSection.hour + 1 < 24
    ) {
      <span class="time last-time"> {{ lastSection.hour + 1 }}:00 </span>
    }
  </div>
}
